<template>
  <div class="">
    <v-container
      fluid
      class="white elevation-3 margen d-flex"
    >
      <div class="d-flex justify-start ">
        <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/Requisicion">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="mx-auto">
        <h1>Crear Requisicion</h1>
      </div>
    </v-container>

    <v-card class="ma-3 ">
      <v-card-title>Datos:</v-card-title>

      <v-card-text>
        <v-autocomplete label="Asignar a proveedor:" 
          class="mx-1"
          v-model="proveedorSeleccionado"
          :items="proveedores" 
          item-text="NOMBRE"
          item-value="NOMBRE"
          filled
          dense
          return-object
          @input="getArticulos"
          />

        <v-menu
          v-model="modalFecha"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              filled
              light
              v-model="fechaSeleccionada"
              label="Fecha a entregar"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              @click="LOG"
            >
            </v-text-field>
          </template>
          <v-date-picker
            v-model="fechaSeleccionada"
            @input="modalFecha = false"
            :min="minFecha[0]"
          >
          </v-date-picker>
        </v-menu>

        <v-text-field label="Descripcion" v-model="descripcion" filled dense />

        <v-divider></v-divider>
        <!-- TABLA ARTICULOS -->
        <div>
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <span
              class="mouse noselect"
              v-ripple
              @click="mostrarArticulos = !mostrarArticulos"
            >
              Articulos
              <v-icon dense light>
                {{ iconoFlecha }}
              </v-icon>
            </span>
          </div>

          <transition name="fade ">
            <v-row v-if="mostrarArticulos" class="allB mt-2 ">
              <!-- PRIMERA TABLA -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="">
                <v-card-title class="pt-0">
                  <div>
                    <div>
                      Seleccionar Articulos
                      <v-btn
                        @click="getArticulos"
                        small
                        text
                        class="success mx-2"
                        >Actualizar</v-btn
                      >
                    </div>
                  </div>

                  <v-divider dark class="ma-4" inline></v-divider>
                  <v-divider dark class="ma-4" inline></v-divider>

                  <v-text-field
                    v-model="buscador"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  />
                </v-card-title>

                <v-data-table
                  class="elevation-1 grey lighten-2 tamTexto"
                  :headers="columnasTabla1"
                  :items="articulos"
                  :search="buscador"
                  :loading="cargando"
                  :footer-props="{
                    'items-per-page-options': [5, 10, 15, 20],
                  }"
                  :items-per-page="5"
                >
                  <template v-slot:[`item.actionEditar`]="{ item }">
                    <v-btn
                      @click="AgregarArticulo(item)"
                      small
                      light
                      class="amber lighten-2"
                      style=""
                    >
                      Agregar
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <div v-if="mensajeTabla!=''">
                      <v-alert color="yellow lighten-3" class="ma-auto">
                        {{mensajeTabla}}
                      </v-alert>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
              <!-- TERMINA LA PRIMERA TABLA -->
          <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>
          <!-- SEGUNDA TABLA -->
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="">
                <v-card-title class="pt-0 justify-space-between">
                  <span>Articulos Agregados </span>

                  <!-- <v-divider dark class="ma-4" inline></v-divider> -->
                  <v-spacer></v-spacer>
                  <div class="d-flex justify-center">

                  <div class="tamTexto1 mx-4 d-flex align-end" style="fit-content">
                    <span class="noBreak">Descuento pronto pago: </span>
                    <v-text-field v-model="descuentoPP" @input="getTotal"
                    type="number" step="1.0" min="0" single-line hide-details class="mx-1 inputDescuento"/> 
                    <!-- <span class="noBreak"> en: </span>
                    <v-combobox :items="descuentos" v-model="descuento" 
                    item-text="nombre" item-value="nombre" @input="getTotal" 
                    single-line hide-details class="mx-1"/> -->
                  </div>
                  </div>

                  <v-spacer></v-spacer>
                  
                  <v-text-field
                    v-model="buscador2"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  />
                </v-card-title>

                <v-data-table
                  :items="articulosAgregados"
                  class="elevation-1 grey lighten-2 tamTexto"
                  :headers="columnasTabla2"
                  :search="buscador2"
                  item-key="ARTICULO_ID"
                >
                  <template v-slot:[`item.AccionCantidad`]="{ item }">
                    <v-text-field v-model="item.CANTIDAD"
                      label="" 
                      type="number" 
                      min="1"
                      hide-details
                      dense
                      single-line
                      @input="calcularTotales(item)"/>
                  </template>

                  <template v-slot:[`item.AccionNotas`]="{ item }">
                    <v-textarea
                      v-model="item.DESCRIPCION"
                      dense
                      auto-grow
                      rows="1"
                      hide-details=""
                    />
                  </template>

                  <template v-slot:[`item.Precio`]="{ item }">
                  <v-text-field
                    v-model="item.PRECIO"
                    label=""
                    type="number"
                    min="0"
                    dense
                    step=".5"
                    hide-details
                    single-line
                    prefix="$"
                    @input="calcularTotales(item)"
                  />
                  </template>

                  <template v-slot:[`item.AccionCantidadDescuento1`]="{ item }">
                  <v-text-field
                    v-model="item.DESCUENTO1"
                    type="number"
                    :max="item.MAXIMO"
                    min="0"
                    dense
                    hide-details
                    single-line
                    @input="calcularTotales(item)"
                  />
                  </template>

                  <template v-slot:[`item.AccionCantidadDescuento2`]="{ item }">
                  <v-text-field
                    v-model="item.DESCUENTO2"
                    type="number"
                    :max="item.MAXIMO"
                    min="0"
                    dense
                    hide-details
                    single-line
                    @input="calcularTotales(item)"
                  />
                  </template>

                  <template v-slot:[`item.AccionDescuento`]="{ item }">
                  <v-autocomplete
                    v-model="item.TIPODESCUENTO"
                    label="Tipo"
                    item-text="nombre"
                    item-value="nombre"
                    :items="descuentos"
                    dense
                    hide-details
                    single-line
                    @input="calcularTotales(item)"
                  />
                  </template>

                  <template v-slot:[`item.AccionImporte`]="{ item }" @click.left="calcularTotales(item)">
                    <v-text-field v-model="item.TOTAL" prefix="$" class="font-weight-regular"  readonly/>
                  </template>

                  <template v-slot:[`item.AccionQuitar`]="{ item }">
                    <v-btn @click="QuitarArticulo(item)"
                    small text color="red darken-1" icon>
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                    
                  </template>
                  <template v-slot:footer>
                        <div v-if="articulosAgregados.length > 0" class="d-flex justify-end ml-auto align-center" style="width:50%;">
                          <span class="mx-2">Subtotal: </span>
                          <v-text-field :value="'$'+total.toFixed(2)" class="font-weight-regular" style="max-width:fit-content;" readonly/>
                        </div>
                      </template>
                </v-data-table>
              </v-col>
              <!-- TERMINA LA SEGUNDA TABLA -->
            </v-row>
          </transition>

        </div>
      </v-card-text>

      <v-divider></v-divider>
      <!-- BOTONES -->
      <v-card-actions class="d-flex justify-space-around">
        <v-btn class="grey darken-1" dark @click="salir">Cancelar</v-btn>
        <v-btn class="primary" dark @click="crearRequisicion">Crear Requisicion</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //DATOS PARA MANDAR A BACKEND
      fechaSeleccionada: '',
      descripcion: '',
      articulosAgregados: [],
      proveedorSeleccionado:null,
      descuentoPP:0.0,
      descuento:null,
      total:0,
      articulosProveedor:[],

      //DATOS PARA MOSTRAR/MODIFICAR
      modalFecha: false,
      minFecha: "",
      proveedores:[],

      // TABLA/s ARTICULOS
      articulos: [],
      descuentos:[{nombre: 'PORCENTAJE'},{nombre: 'IMPORTE'}],
      buscador: "",
      buscador2: "",
      cargando: false,
      mostrarArticulos: true,
      columnasTabla1: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Articulo", value: "NOMBRE", filterable:false },
        { text: "Agregar", sortable: false, value: "actionEditar", align: "right",},
      ],
      columnasTabla2: [
        { text: "Clave",    value: "CLAVE_MSP", divider: true, align: "start", width:'10%'},
        { text: "Cantidad", sortable: false, value: "AccionCantidad", divider: true, width:"5%" },
        { text: "Articulo", value: "NOMBRE", divider: true, align: "start", width:"30%" },
        { text: "Obs.",    sortable: false, value: "AccionNotas", divider: true, width:'20%' },
        { text: "Precio",  sortable: false, value: "Precio", divider: true, width:"120px"},
        { text: "Descto.", sortable: false, value: "AccionCantidadDescuento1", divider: true, width:"3%"},
        { text: "Descto.", sortable: false, value: "AccionCantidadDescuento2", divider: true, width:"30px"},
        // { text: "Descuento en", sortable: false, value: "AccionDescuento", divider: true, width:"140px"},
        { text: "Importe", sortable: false, value: "AccionImporte", divider: true, width:""},
        { text: "Accion", sortable: false, value: "AccionQuitar", divider: true, align: "right", width:"5px"},
      ],
      // ----------------------------------------------------------------------
      // mensajes tabla
      mensajeTabla:'',
    };
  },

  // -----------------------------------------------------------------------------
  computed: {
    ...mapGetters(["getFechaActual", "getURLAPI","getUsuario"]),

    iconoFlecha: function () {
      return this.mostrarArticulos
        ? "mdi-arrow-up-drop-circle"
        : "mdi-arrow-down-drop-circle";
    },
  },
  
  watch: {
    articulosAgregados:{
      handler(){
        // console.log(old,valor);
        this.getTotal();
        // console.log("entro a handler");
      }, deep:true
    }
  },

  // -----------------------------------------------------------------------------
  methods: {
    // ---------------------------------------------------------------------------
    async getProveedores(){
      this.proveedores = (await axios.get(`${this.getURLAPI}/Show/allProveedores`)).data
    },
    // -----------------------------------------------------------------------------
    AgregarArticulo(articulo) {
      console.log(!this.articulosAgregados.some(art => articulo.ARTICULO_ID === art.ARTICULO_ID))
      if (!this.articulosAgregados.some(art => articulo.ARTICULO_ID === art.ARTICULO_ID)) {
        articulo.TOTAL = 0;
        this.articulosAgregados.push(articulo);
        this.calcularTotales(articulo);
        console.log(this.articulosAgregados);
      }
    },
    // -----------------------------------------------------------------------------
    QuitarArticulo(articulo) {
      const index = this.articulosAgregados.indexOf(articulo);
      if (index > -1) {
        this.articulosAgregados.splice(index, 1);
      }
      console.log(this.articulosAgregados);
    },
    // -----------------------------------------------------------------------------
    getArticulos() {
      try{
      console.time("articulosc");
      this.cargando = true;
      this.articulos = [];

      let pId = this.proveedorSeleccionado != null ? this.proveedorSeleccionado.PROVEEDOR_ID_MSP: 1;
      let nombre =  this.proveedorSeleccionado != null ? this.proveedorSeleccionado.NOMBRE: "f";
      
      let datosForm = new FormData();
      datosForm.append("PROVEEDOR_ID_MSP",  pId);
      datosForm.append("NOMBRE",            nombre);
      // console.log(this.proveedorSeleccionado.PROVEEDOR_ID_MSP);
      // this.articulos = ( await axios.get(`${this.getURLAPI}/Show/allArticles`)).data;
      axios.post(`${this.getURLAPI}/Requisiciones/allArticles`,datosForm)
      .then( ({data}) =>{

        if(!data.STATUS && data.STATUS != 'ERROR'){
          this.mensajeTabla = '';
          this.articulos = data;
          this.articulos.forEach( (articulo) => {
            articulo.CANTIDAD = 1;
            articulo.PRECIO = articulo.PRECIO_UNITARIO ?? 1;
            articulo.DESCUENTO1 = 0;
            articulo.DESCUENTO2 = 0;
            articulo.TIPODESCUENTO = this.descuentos[0].nombre;
            articulo.MAXIMO = 100;
          });
        this.cargando = false;
        console.log(this.articulos);
        }else{
          this.mensajeTabla = data.MSG
        this.cargando = false;
        }
      })
      .catch( () =>{
        this.articulos=[];
        this.cargando = false;
        console.timeEnd("articulosc");
      })
      // console.log(this.articulos);
      }
      catch(err){
        this.articulos=[];
        this.cargando = false;
        console.log(err);
      }
    },
    // -----------------------------------------------------------------------------
    maxDescuento( item ){
      if (item.TIPODESCUENTO.nombre == "PORCENTAJE") {
        item.MAXIMO=100;
      } else{
        item.MAXIMO=100000;
      }
    },
    // -----------------------------------------------------------------------------
    salir() {
      let close = confirm("¿Seguro que quieres salir de la pagina?");
      if (close) {
        this.$router.push("/requisicion");
      }
    },
    // -----------------------------------------------------------------------------
    crearRequisicion(){
      if( this.fechaSeleccionada !== '' && 
          this.articulosAgregados.length > 0 &&
          this.proveedorSeleccionado != null)
      {
        let datosForm = new FormData();
        datosForm.append("FECHA",           this.fechaSeleccionada);
        datosForm.append("DESCUENTOPP",     this.descuentoPP);
        datosForm.append("USUARIO_CREADOR", this.getUsuario);
        datosForm.append("ARTICULOS",       JSON.stringify(this.articulosAgregados));
        datosForm.append("PROVEEDOR",       this.proveedorSeleccionado.PROVEEDOR_ID);
        datosForm.append("DESCRIPCION",     this.descripcion);
        

        axios.post(`${this.getURLAPI}/Requisiciones/insertarRequisicion`,datosForm)
        .then( ({data}) => {
          console.log(data);

          let status = data.STATUS;
          this.$root.vtoast.show(
            { message: data.MSG, color: status == 'OK' ? 'success darken-2':'red darken-2', 
              timer:10000, icon: status == 'OK' ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          if (status == 'OK') this.$router.push("/requisicion");

        } )
        .catch( ()=> {
          this.$root.vtoast.show(
            { message: 'Ocurrio un problema en el servidor', color:'red darken-2', 
              timer:10000, icon:'mdi-alert-circle-outline' } )
        })

      }
      else{
        this.$root.vtoast.show(
          {message: 'Verifica los campos.', color:'black darken-2', timer:10000, icon:'mdi-alert-circle-outline'}
        )
      }
    },
    // ---------------------------------------------------------------------------
    LOG(){
      console.log(this.articulosAgregados);
    },
    // ---------------------------------------------------------------------------
    // preciosArticulos( precio ){
    //   let tot = 0;

    //   tot = parseInt( precio );
      
    //   this.total += tot;
    //   // console.log("se cambio" + nuevo);
    // },

    // ---------------------------------------------------------------------------
    calcularTotales( item ){
      let total = Number(item.CANTIDAD * item.PRECIO);
      let index = this.articulosAgregados.indexOf(item);
      // console.log("entro a totales");

      if(item.TIPODESCUENTO == 'PORCENTAJE') {
      // console.log("entro a PORCENTAJE");
        // item.TOTAL = (total - (total * item.DESCUENTO1)/100 - (total * item.DESCUENTO2)/100)//.toFixed(2);
        // console.log(item.TOTAL);

        // RESTAR DESCUENTO 1
        total = total - (total * item.DESCUENTO1) / 100;
        // RESTAR DESCUENTO 2
        total = total - (total * item.DESCUENTO2) / 100;
        // ASIGNAR NUEVO TOTAL AL ITEM
        item.TOTAL = total;
      }
      else{
        // console.log("entro a IMPORTE");
        item.TOTAL = (total - Number(item.DESCUENTO1) - Number(item.DESCUENTO2))//.toFixed(2);
        // console.log(item.TOTAL);
      }
      let editado = {...this.articulosAgregados[index], ...{item}}
      this.articulosAgregados.splice(index,1,editado)
    },
    
    // ---------------------------------------------------------------------------
    getTotal(){
      this.total = 0;
      let resultado = 0;
      this.articulosAgregados.forEach( (articulo) =>{  
        resultado += articulo.TOTAL;
      })
        this.total = resultado;
      // console.log("s",this.descuento.nombre);
      // if (this.descuento == 'PORCENTAJE')
      //   this.total = resultado - (resultado * this.descuentoPP)/100
      // else 
      //   this.total = resultado - this.descuentoPP
    },
  },

// -----------------------------------------------------------------------------
  created() {
    document.title = "Crear Requisicion | Bombas y Suministros del Norte";
    this.minFecha = this.getFechaActual.split(" ");
    this.descuento = this.descuentos[0].nombre
    this.getArticulos();
    this.getProveedores();
    

    // total1 = $computed( () => )
  },
};
</script>

<style>
.allB {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 1px 1px 1px 1px;
}
input[type=number] {
  text-align: right;
}

.inputDescuento{
  width: 10ch;
}

/* .v-input {
  font-size: 12px;
} */
</style>
